if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'}); 
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          const mainCatItems = document.querySelectorAll(".lk-cart-drawer-items .cart-item");
          const shippingToggle = document.querySelector("#shipping-product-toggle");

          // Initial setup: Check the toggle if the product exists in the cart
          mainCatItems.forEach(item => {
            if (item.getAttribute("data-variant-id") === shippingToggle.getAttribute("data-product-id")) {
              shippingToggle.checked = true;
            }
          });

          // Add event listener to handle toggle changes
          shippingToggle.addEventListener("change", function() {
            const catItems = document.querySelectorAll(".lk-cart-drawer-items .cart-item");
            var prio_flag = true;
            var prio_item;

            catItems.forEach(item => {
              if(item.getAttribute("data-variant-id") == this.getAttribute("data-product-id")) {
                  prio_flag = false;
                  prio_item = item;
              }
            });

            if (this.checked) {
              // Add the priority product if it's not in the cart
              if (prio_flag) {
                  this.closest(".shipping-product__wrapper").querySelector(".product-form__submit").click();
              }
            } else {
              // Remove the priority product from the cart if it exists
              if (prio_item) {
                prio_item.querySelector("cart-remove-button").click();
              }
            }
          });

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener('variant:changed', (event) => {
  const variant = event.detail.variant;
  const bisWrapper = document.querySelector('#klaviyo-bis-trigger-wrapper');
  const bisTrigger = document.querySelector('.klaviyo-bis-trigger');

  if (!variant || !bisWrapper || !bisTrigger) return;

  // richtige Variant-ID setzen
  bisTrigger.setAttribute('data-variant', variant.id);

  // ein-/ausblenden
  if (variant.available) {
    bisWrapper.style.display = 'none';
  } else {
    bisWrapper.style.display = 'block';
  }
});

